import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function TossFail() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const postId = sp.get("postId");
  const message = sp.get("message") || sp.get("code") || "결제가 완료되지 않았습니다.";

  return (
    <div className="p-6 space-y-3 text-sm">
      <div className="font-semibold">결제 실패</div>
      <div className="text-gray-700">{message}</div>
      <Button variant="outline" onClick={() => navigate(postId ? `/bus-hub/${postId}/manage` : "/bus-hub")}>
        돌아가기
      </Button>
    </div>
  );
}
